import { Draft, produce } from "immer"

import { ConsentListItem, IAppConsentsModel } from '../../models/settings/consent.fetch.model'
import { ConsentFetchedActions, CONSENT_FETCHED, APP_CONSENTS_FETCHED, APP_CONSENTS_CHECK_ONE, APP_CONSENTS_TOGGLE_ALL, APP_CONSENTS_VALIDATE_ALL } from "../actions/consent-action";
import { ConsentState } from "../types";

const mapFetchedConsentsToModel = (consents: ConsentListItem[]): IAppConsentsModel[] | [] => {
  const mappedConsents: IAppConsentsModel[] = []

  if(!consents?.length){
     console.warn("Obiekt zgód pusty lub niezdefiniowany")
     return mappedConsents
  }
  else {
     for (const consent of consents) {
        if(consent.title){
           const mappedConsentObject: IAppConsentsModel = {
              consentId: consent.id,
              isRequired: consent.isRequired,
              text: consent.text,
              title: consent.title,
              isActive: consent.isActive,
              hasError: false,
              isChecked: false,
           }
           mappedConsents.push(mappedConsentObject)
        }
     }
  }
  return mappedConsents
}

  
  export const intialStateConsent: ConsentState = {
      consent: [],
      appConsents: [],
  };
  
  export function consentReducer(state: ConsentState = intialStateConsent, action: ConsentFetchedActions) {
    return produce(state, (draft: Draft<ConsentState>) => {

      switch (action.type) {
        case CONSENT_FETCHED: {
          draft.consent = action.payload.list

          break;
        }
        case APP_CONSENTS_FETCHED: {
          draft.appConsents = mapFetchedConsentsToModel(action.payload.list)

          break;
        }
        case APP_CONSENTS_CHECK_ONE: {
          const appConsent = draft.appConsents.find((consent) => consent.consentId === action.payload)

          if (appConsent) {
            appConsent.isChecked = !appConsent.isChecked
            appConsent.hasError = appConsent.isRequired && !appConsent.isChecked
          }

          break;
        }
        case APP_CONSENTS_VALIDATE_ALL: {
          draft.appConsents.forEach((consent) => {
            if (consent.isRequired && !consent.isChecked) {
              consent.hasError = true
            }
          })

          break;
        }
        case APP_CONSENTS_TOGGLE_ALL: {
          draft.appConsents.forEach((consent) => {
            consent.isChecked = action.payload;
            consent.hasError = consent.isRequired && !action.payload;
          })

          break;
        }
        default:
          break;
      }
    });
  }